const LIFESTYLES = {
  pPlaterApproved: 'P-Plate Approved',
  safeCarsForFamilies: 'Safe Cars for Families',
} as const;

export type Lifestyle = (typeof LIFESTYLES)[keyof typeof LIFESTYLES];

export default LIFESTYLES;
